import { useTranslation } from 'react-i18next';
import usePopUp from 'src/hook/modal/usePopUp';
import { IconLocation } from 'src/utils/URLUtils';
import Modal from '../Modal/Modal';
import styles from './PopUp.module.scss';

const PopUp = () => {
    const { hide, isOpen, title, width,
        message, primaryButtonText,
        primaryButtonClick, secondaryButtonText,
        secondaryButtonClick, showSecondaryButton,
        showCloseButton, children: stateChildren, onClose } = usePopUp();
    const { t, i18n } = useTranslation();

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
        hide();
    };

    const handlePrimaryButtonClick = () => {
        if (primaryButtonClick) {
            primaryButtonClick();
        }
        hide();
    };

    const handleSecondaryButtonClick = () => {
        if (secondaryButtonClick) {
            secondaryButtonClick();
        }
        hide();
    };

    return (
        <Modal isOpen={isOpen} onClose={handleClose} width={width}>
            {stateChildren ? (
                stateChildren
            ) : (
                <div className={styles.popUp}>
                    <div className={styles.header}>
                        <h2 dir={i18n.dir()} className={styles.title}>{t(title || '')}</h2>
                        {showCloseButton && (
                            <img src={IconLocation('x')}
                                onClick={handleClose}
                                alt="close" />
                        )}
                    </div>
                    <p dir={i18n.dir()} className={styles.message}>{t(message || '')}</p>
                    <hr />
                    <div className={styles.buttonContainer}>
                        {showSecondaryButton && (
                            <button
                                className={`secondaryButton`}
                                onClick={handleSecondaryButtonClick}
                            >
                                {t(secondaryButtonText || '') || t('Cancel')}
                            </button>
                        )}
                        <button
                            className={`${styles.button} ${styles.primaryButton}`}
                            onClick={handlePrimaryButtonClick}
                        >
                            {t(primaryButtonText || '') || t('OK')}
                        </button>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default PopUp;
